import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import moment from 'moment';

import {api} from '../../actions/_request';
import * as actions from '../../actions/categorias';

const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);

class ProspectoModal extends React.Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			categorias: {
                id: null,
                nombre: "",            
            },
            action: 'save',
        };

		this.handleChangeInput 		= this.handleChangeInput.bind(this);
		
		this.handleSubmit 			= this.handleSubmit.bind(this);

	}

    componentDidMount(){

        let prospectoid = this.props.prospectoid;
        //console.log(this.props.prospectoid)
        let self = this;

        if(prospectoid > 0 && prospectoid !== self.state.categorias.id)
        {
            api().get(`/categorias/${prospectoid}`)
            .then(function(response)
            {
                if(response.status === 200)
                {
                   
                    self.setState({
                        categorias: response.data,
                        action: 'update'
                    });             

             }
            });


        }
        else if(prospectoid === null && self.state.categorias.id)
        {
            self.asNothing();
        }
    }

    asNothing()
    {
        this.setState({
          departamento: {
                id: null,
                nombre: "",               
            
            },
            action: 'save',
        });
    }

	handleChangeInput(event)
	{
		const target 	= event.target;
		const value 	= target.type === 'checkbox' ? target.checked : target.value;
		const name 		= target.name;

		let {categorias} = this.state;
		categorias[name] = value;
		this.setState({categorias: categorias});
  

	}
objeto_mayusculas(objeto){
         // for (var key in objeto) {
         //        if (objeto.hasOwnProperty(key)) {
         //            // var valor=String(objeto[key]).toUpperCase();                 
         //            // console.log('valor---->',valor)
                     
         //                 objeto[key] = String(objeto[key]).toUpperCase() ;
         //                 if( String(objeto[key]).toUpperCase()==='NULL')
         //                    objeto[key] ='';
                     
         //            // console.log(key + " = " + objeto[key]);
         //        }
         //      }
              return objeto;
    }
	
	
   
	handleSubmit(evt)
	{
		evt.preventDefault();
		let {categorias} = this.state;
		var self = this;
        //console.log(self.state.action);
		// post

        

        categorias=this.objeto_mayusculas(categorias);
		this.props[self.state.action](categorias, () => {

			swal({
				title: 'Categoria',
				text: "Se ha guardado con éxito",
				type: 'success',
				// showCancelButton: true,
				// confirmButtonColor: '#3085d6',
				// cancelButtonColor: '#d33',
				confirmButtonText: 'Continuar!'
			}).then((result) => {
				if (result.value) {
					// swal(
					// 	'Deleted!',
					// 	'Your file has been deleted.',
					// 	'success'
					// 	)
                    self.asNothing();
					self.props.toggle();
                    
				}
			})

		});
	}

	render()
	{
		let {categorias} = this.state;

		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>

                    <div className="row">
                       
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label htmlFor="">Nombre</label>
                                <input 
                                 type="text" 
                                 name="nombre" 
                                 value={categorias.nombre}
                                 onChange={this.handleChangeInput} 
                                 className="form-control texto_normal" />
                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    
                    	
                    	<div>
                    		<Button color="success" type="submit" type="submit">
                    			<IconSave />&nbsp;Guardar
                    		</Button>{' '}
                    		<Button color="danger" onClick={this.props.toggle}>
		                    	Cancelar
		                    </Button>
                    	</div>
                    
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
          categorias: state.categorias,
        
    }
};

export default connect(mapStateToProps,actions)(ProspectoModal)



// WEBPACK FOOTER //
// ./src/views/categorias/modal.js